export default __webpack_public_path__ + "static/media/default_user_pic.94d1781e.svg";